module.exports = __webpack_public_path__ + "img/Thumbnail4.66d94d79.png";